export const config: any = {
    pageAddress: "https://hiveslotgames.com",
    gameServerAddress: "https://video-poker-server.hiveslotgames.com",
    gameId: "Video_Poker_Double_Up",
    betValues: [0.1, 0.2, 0.3, 0.4, 0.5, 1.0, 2.0, 2.5, 3.0, 4.0, 5.0, 7.5, 10.0, 12.5, 15.0, 20.0],
    maxDoublesForOtherCombination: 5,
    maxDoublesForFourOfKind: 4,
    maxDoublesForStraightFlush: 3,
    maxDoublesForRoyalFlush: 1,
    displayCurrency: "HIVE",
    baseCurrency: "mHIVE",
    baseCurrencyDenomination: 1000,
    betDisplayPrecision: 4,
};



// WEBPACK FOOTER //
// ./src/config.ts